import { useState } from "react";
import css from "./styles.module.scss"; 

type Props = {
  name?: string,
  label?: string,
  onChange?: (e:any) => void,
  onBlur?: (e:any) => void,
  defaultValue?: string,
  className?:string,
  textarea?: boolean,
  rows?:number,
  inputRef?: any,
  invalid?: string | null,
  button?: {
    props: any,
    text: string |JSX.Element
  } | false,
}

const STKTextField = ( props:Props ) => {

  const [value, setValue] = useState(props.defaultValue);

  const onChange = ( e: any ) => { 
    setValue(e.target.value);
    
    if ( props.onChange ) {
      props.onChange(e);
    }
  }

  const inputProps = {
    ref: props.inputRef,
    name: props.name,
    defaultValue: props.defaultValue,
    onChange: onChange,
    onBlur: props.onBlur,
    className: ( value ? css.notEmpty : ''),
    type: 'text'
  }

  if ( props.name == 'email' ) {
    inputProps.type = 'email';
  }
  if ( props.name == 'phone' ) {
    inputProps.type = 'tel';
  }

  return(
    <div className={css.textfieldWrapper + ' ' + props.className}>
      <div className={css.textField + ' ' + ( props.invalid ? css['textField--invalid'] : '') }> 
        { props.textarea ?
          <textarea {...inputProps} rows={props.rows !== undefined ? props.rows : 4 } ></textarea>
          :
          <input {...inputProps} />
        }
        <label>{props.label}</label>
      </div> 
      <span className={css.textFieldInvalidMessage}>{props.invalid}</span>
      { props.button &&
          <button {...props.button.props}>{props.button.text}</button>
      }
    </div>
  );
}

export default STKTextField;